export const CAST_LIST = [
  {
    id : 1,
    castId: 'bOanp5uBfnRXpfs70YlmKec3XtT2',
    name : "エルメス・ディアーナ",
    info : ""
  },
  {
    id : 2,
    castId: 'XlIiG1i6TdVipL2dL7obPtShb9r1',
    name : "リリィ・ペリドット",
    info : ""
  },
  {
    id : 3,
    castId: '7x8A8AAmGtPaJSOnR2WAXHsg6f13',
    name : "ニーナ・ファリーダ",
    info : ""
  },
  {
    id : 4,
    castId: 'vVH9pKYSfNhqNSDyn6lVWjQRW9n2',
    name : "ショール・ラグランジア",
    info : ""
  }
]
